import {
  DAY,
  type ExtendedLocationData,
  HOUR,
  type LocationGetInput,
  type LocationGetSuccess,
  type LocationId,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { locationKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useLocation(
  locationId: LocationId | undefined,
  options?: {
    enabled?: boolean
    extended?: boolean
    version?: number
  }
): GetHookResponse<ExtendedLocationData> {
  const { enabled = true, extended = true, version = 3 } = options ?? {}
  return useTantalimQuery<LocationGetInput, LocationGetSuccess, ExtendedLocationData>({
    url: '/location/get',
    queryKey: locationKey(locationId, extended),
    input: {
      locationId: locationId ?? 'TLoc:NO_LOCATION_PROVIDED',
      version,
      extended,
    },
    convertResponse: (data) => data.location,
    options: {
      enabled: Boolean(locationId) && enabled,
      gcTime: DAY,
      staleTime: HOUR,
      retry: false,
    },
  })
}
